import qs from 'qs';
import {
  UPLOAD_REPAIRS_IMAGE,
  REPLACE_REPAIRS_IMAGE,
  DELETE_REPAIRS_IMAGE,
  REASONS_HIERARCHY,
} from '../constants/endpoints';
import { store } from '../store';

export const uploadImage = () => async (file) => {
  const {
    page: { browserFingerprint },
  } = store.getState();

  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(UPLOAD_REPAIRS_IMAGE, {
      method: 'POST',
      body: formData,
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    });
    const images = await response.json();
    return images[0];
  } catch (error) {
    return Promise.reject(error);
  }
};

export const replaceImage = () => async (fileName, file) => {
  const {
    page: { browserFingerprint },
  } = store.getState();
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(REPLACE_REPAIRS_IMAGE(fileName), {
      method: 'POST',
      headers: {
        'Content-Type': undefined,
        'narvar-tfid': browserFingerprint,
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteImage = () => async (fileName) => {
  const {
    page: { browserFingerprint },
  } = store.getState();

  try {
    const response = await fetch(DELETE_REPAIRS_IMAGE(fileName), {
      method: 'DELETE',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    });
    return response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getReasonHierarchy =
  (store) =>
  async (category, itemProperties = []) => {
    const {
      page: { productType, browserFingerprint, locale },
      retailerSettings: { name: retailerName } = {},
      returnsSettings: {
        [productType]: { additionalReasonHierarchyParams = [] },
      },
    } = store.getState();
    const criteriaProperty =
      itemProperties.find((property) => property.key.toLowerCase() === 'criteria') || {};
    const categoryValue = criteriaProperty.value || category;

    const baseParams = {
      locale,
      type: productType,
      category: categoryValue,
    };

    const urlParams = additionalReasonHierarchyParams.reduce((finalParams, param) => {
      const matchingProperty = itemProperties.find((property) => property.key === param);
      return matchingProperty
        ? {
            ...finalParams,
            [param]: matchingProperty.value,
          }
        : finalParams;
    }, baseParams);

    try {
      const response = await fetch(
        REASONS_HIERARCHY({ retailerName, params: qs.stringify(urlParams) }),
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'narvar-tfid': browserFingerprint,
          },
        },
      );
      return response.json();
    } catch (error) {
      console.error(error);
    }
  };
